import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
declare var jquery: any;
declare var $: any;
import { GridOptions } from "ag-grid/main";
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AdminService, RaterTypeDto } from 'app/services/admin/AdminService';
import { CoachService, ImportRatersDto } from 'app/services/coach/CoachService';
import { ClientsService, RaterDto } from 'app/services/client/ClientsService';
import { RatersService } from 'app/services/rater/RatersService';
import { Globals } from 'app/globals';
import { ToastrService } from 'ngx-toastr';
import { RaterTypesForModalComponent } from '../c-rater-types/rater-types-for-modal/rater-types-for-modal.component';
import { Router } from '@angular/router';
// import { setTimeout } from 'timers';
import { isUndefined } from 'util';
import { DuplicateEmailsManager } from '../../shared/manager/duplicate-emails-manager';
//import { DuplicateEmailsManager } from 'src/app/shared/managers/duplicate-emails-manager';

@Component({
  selector: 'app-raters-modal',
  templateUrl: './raters-modal.component.html',
  styleUrls: ['./raters-modal.component.scss']
})
export class RatersModalComponent implements OnInit {

    @ViewChild('ratersModal', {static: true}) public modal: ModalDirective;
    @ViewChild('raterTypesForModal', {static: true}) public raterTypesForModal: RaterTypesForModalComponent;

    addedRaters: any[] = [];
    editedRaters: any[] = [];
    deletedRaters: any[] = [];
    categoryMin: number;
    assignmentId: number;
    raters: any[] = [];
    loading: boolean = true;
    raterTypes: any[] = [];
    inProgress: boolean = false;
    addingNewRater: boolean = false;

    /*new rater*/
    rater = {
        email: "",
        raterType: 0,
        firstName: "",
        lastName: ""
    }

    pristineRaters: any[] = [];
    arrActiveCategories: any[] = [];
    noRaters: boolean = false;
    lastRelationshipClicked: number;
    tempId = "tempId";
    counter = 0;
    raterTypesStandartData: string[] = [];
    raterTypesCustomData: string[] = [];
    raterTypesStandartDataHeaders: any[];
    raterTypesCustomDataHeaders: any[];
    raterTypesStandartGridApi;
    raterTypesCustomGridApi;
    isStandard: boolean = true;
    lastCategory: string = 'categories';
    ratertoDelete: any;
    bulkDeleteCategoryId: any;
    pristineCategories: any[] = [];
    executed: boolean = false;
    rtgridOptions: GridOptions;
    //parent: any;

    fileName: string = "";
    blobFile: any = null;
    importRaterPageIdx: number = 0;

    languages: string[] = [];
    language: any;

    expiresOn: Date = new Date();
    sentDate: Date = new Date();
    date1: Date = new Date();

    settings = {
        bigBanner: false,
        timePicker: false,
        format: 'MM-dd-yyyy',
        defaultOpen: false
    };

    hours: string[] = [
        "00:00 AM",
        "01:00 AM",
        "02:00 AM",
        "03:00 AM",
        "04:00 AM",
        "05:00 AM",
        "06:00 AM",
        "07:00 AM",
        "08:00 AM",
        "09:00 AM",
        "10:00 AM",
        "11:00 AM",
        "12:00 PM",
        "01:00 PM",
        "02:00 PM",
        "03:00 PM",
        "04:00 PM",
        "05:00 PM",
        "06:00 PM",
        "07:00 PM",
        "08:00 PM",
        "09:00 PM",
        "10:00 PM",
        "11:00 PM"
    ];
    importDate: Date = new Date();
    addRaterPageIdx: number = 0;

    scheduledDate: string = "";
    expiresIn: any;
    selectedHour: string = "";
    scheduleSelected: string = "";
    selectedGtmValue: number;
    id: number;
    clientId: number;
    addingRater: boolean = false;
    modalIndex: number;
    tcounter: number = 0;
    onlyOneceEdit: boolean = false;
    onlyOneceSend: boolean = false;
    onlyOneceCopy: boolean = false;
    parent: any;
    clientEmail: string = "";

    //move entry
    moveActiveCategories: any[] = [];
    selectedRaterIdToMove: any;
    moveRowEntry: any;

    rname: string = '';
    currentSelectedRelationshipsTab: number = 2;
    action: string;
    currentRaterId: number;
    addNewRelationship: boolean = false;
    categoryToRemove: number;
    assignmentNewCategories: any;
    newCategory: number;
    raterCompleteAsignments: Array<any>;

    constructor(
        public _AdminService: AdminService,
        public _CoachService: CoachService,
        private _RatersService: RatersService,
        public _Globals: Globals,
        private router: Router,
        private _ClientsService: ClientsService,
        public _toastr: ToastrService
    ) { }

    ngOnInit() {
        console.log('ngOnInit');
        this.getLanguages();
        this.rtgridOptions = {};
        this.rtgridOptions.rowHeight = 45;
        this.rtgridOptions.headerHeight = 40;

        this.getCoachAssignedAssessmentsByType(1);
        this.getCoachAssignedAssessmentsByType(2);

        this.getRaterTypesForCoach(false);
    }

    getLanguages() {
        this._AdminService.getLanguages().subscribe((data: any) => {
            console.log('languages', data.result);
            let result = data.result.Result;

            if (result <= -10) {
                //this.toastr.warning('Expired token please login again.', 'ELI');
                this.router.navigate(['/login']);
                this._Globals.deleteAllStorage();
                return;
            }

            let _data = JSON.parse(data.result.Data);
            this.languages = _data;
        });
    }

    onShown() {
    }

    close(): void {
        this.modal.hide();
        this.addedRaters = [];
        this.editedRaters = [];
        this.deletedRaters = [];
        this.raters = [];
        this.arrActiveCategories = [];
        this.pristineCategories = [];
        this.executed = false;
        $('#rtmainAccordion .panel').css('display', 'none');
        //$('#relationships option')[0].selected = true;
        console.log('closeModal');
        $('.ratersModalAcc div').removeClass('in');
        $('#rtmainAccordion .panel').removeClass('accOpen');
        $('#rtmainAccordion .panel').addClass('accHide');
        $('.panel a').css('color', '#63ceeb');
        $('.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');
        this.hideConfirmCloseRatersModal();

        $('#expiresIn').val(30);
        $('.assignedRadios input:radio[name=schedule]').eq(1).prop('checked', false);
        $('.assignedRadios input:radio[name=schedule]').eq(0).prop('checked', true);
        this.date1 = new Date();
        $('#languages  option').eq(0).prop('selected', true);
        //setTimeout(() => {
        //    $('.ratersModal').remove();
        //    console.log('instance removed');
        //}, 100);
        if (this._Globals.refreshTableOnAssessmentsResults) {
            this._Globals.refreshTableOnAssessmentsResults = false;
            this.parent.getRaters();
            console.log('table Refreshed');
        }
    }

    show(id: number, clientId: number, modalIndex: number, clientEmail:string, parent?: any) {
        this.parent = parent;
        this.modalIndex = modalIndex;
        console.log('rater modal instances', $('.ratersModal'));
        this.id = id;
        this.clientId = clientId;
        this.clientEmail = clientEmail;
        this.getRaters(id, true);
        this.modal.show();
    }

    sizeToFit(gridApi: any) {
        gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    getSelectedRows(gridApi): any {
        console.log("SELECTED", gridApi.getSelectedRows());
        return gridApi.getSelectedRows();
    }

    getRaters(assignmentId: number, refreshData: boolean, oneOpen?: number) {
        console.log('getRaters');
        this.assignmentId = assignmentId;

        this._ClientsService.getRaters(this.assignmentId).subscribe((data: any) => {
            console.log('response_GetRaters', data);

            if (this._Globals.validationToken(data.result.Result)) {

                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                this.pristineRaters = JSON.parse(data.result.Data);

                if (this.addedRaters.length > 0 || this.editedRaters.length > 0 && refreshData) {
                    //updating the properties for edited entries
                    _data.forEach((item, index) => {
                        for (var i = 0; i < this.editedRaters.length; i++) {
                            if (item.Email == this.editedRaters[i].Email) {
                                _data[index] = this.editedRaters[i];
                            }
                        }
                    });
                    this.raters = _data.concat(this.addedRaters);
                    console.log('raters', this.raters);
                } else {
                    //from database
                    if (refreshData) {
                        this.raters = _data;

                        for (var i = 0; i < this.raters.length; i++) {
                            if (i == 0) {
                                $(".ratersModalAcc #acc" + this.raters[i].RelationshipId).insertAfter('.ratersModalAcc #forFirstelement');
                            } else {
                                let beforeElement = this.raters[(i - 1)].RelationshipId;
                                $(".ratersModalAcc #acc" + this.raters[i].RelationshipId).insertBefore('.ratersModalAcc #acc' + beforeElement);
                            }

                            $('.ratersModalAcc #acc' + this.raters[i].RelationshipId).css('display', 'block');
                            $('.ratersModalAcc #acc' + this.raters[i].RelationshipId).removeClass('accHide');
                            $('.ratersModalAcc #acc' + this.raters[i].RelationshipId).addClass('accOpen');
                            //$('#relationships').val(r.RelationshipId);
                        }
                    } else {
                        //this.arrActiveCategories.forEach((r) => {
                        for (var i = 0; i < this.arrActiveCategories.length; i++) {
                            if (i == 0) {
                                $(".ratersModalAcc #acc" + this.arrActiveCategories[i]).insertAfter('.ratersModalAcc #forFirstelement');
                            } else {
                                let beforeElement = this.arrActiveCategories[(i - 1)];
                                $(".ratersModalAcc #acc" + this.arrActiveCategories[i]).insertAfter('.ratersModalAcc #acc' + beforeElement);
                            }
                            $('.ratersModalAcc #acc' + this.arrActiveCategories[i]).css('display', 'block');
                            $('.ratersModalAcc #acc' + this.arrActiveCategories[i]).removeClass('accHide');
                            $('.ratersModalAcc #acc' + this.arrActiveCategories[i]).addClass('accOpen');
                            //$('#relationships').val(r); 
                        }
                    }

                    this.checkRatersAmount();

                    if (!this.executed) {
                        this.executed = true;
                        this.pristineCategories = [];
                        let pristineCategories = $('.ratersModalAcc .accOpen');
                        console.log(pristineCategories);

                        for (var i = 0; i < $('.ratersModalAcc .accOpen').length; i++) {
                            let r = pristineCategories[i].id.match(/\d/g).join(',');
                            r = r.replace(/,/g, '');
                            this.pristineCategories.push(parseInt(r));
                        }
                    }
                    if (isUndefined(oneOpen)) oneOpen = 1;
                    if (oneOpen > 0) {
                        //open the first catefory
                        let firstElement = $('.ratersModalAcc .accOpen a');
                        firstElement[0].click();
                        firstElement[0].children[0].children[1].classList.value = 'fas fa-angle-up';
                    }
                    //this.drawData();
                }

                this.loading = false;
                //this.sizeToFit(this.raterGridApi);
            }
        });
    }

    checkRatersAmount() {
        console.log('checkRatersAmount');
        let accOpen = $('.ratersModalAcc .accOpen').length;
        console.log(accOpen);

        if (accOpen == 0) {
            this.noRaters = true;
        } else {
            this.noRaters = false;
        }
    }

    drawData(relationshipId: number, relationshipMin: number, e?) {
        console.log(e);
        //reset all angle icons down
        if (this.lastRelationshipClicked != relationshipId) {
            $('.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');
        }

        if (e != undefined) {
            //h4 clicked
            if (e.target.nodeName == 'H4') {
                if (e.target.nextElementSibling.classList.value == 'fas fa-angle-up') {
                    e.target.nextElementSibling.classList.value = 'fas fa-angle-down';
                } else {
                    e.target.nextElementSibling.classList.value = 'fas fa-angle-up';
                }
            }

            //a clicked
            if (e.target.nodeName == 'DIV') {
                if (e.target.children[1].classList.value == 'fas fa-angle-up') {
                    e.target.children[1].classList.value = 'fas fa-angle-down';
                } else {
                    e.target.children[1].classList.value = 'fas fa-angle-up';
                }
            }

            //i clicked
            if (e.target.nodeName == 'I') {
                if (e.target.classList.value == 'fas fa-angle-up') {
                    e.target.classList.value = 'fas fa-angle-down';
                } else {
                    e.target.classList.value = 'fas fa-angle-up';
                }
            }
        }

        this.lastRelationshipClicked = relationshipId;

        let filteredRaters = this.raters.filter((r) => {
            if (r.RelationshipId === relationshipId) return r;
        });
        console.log('filteredRaters', filteredRaters);

        //display min message if category doesnt have enought raters
        this.displayMinMessage(relationshipId);

        $('.ratersModalCategoryEntries').html(``);

        let disabled = 'disabled';
        if (filteredRaters.length > 0) {
            filteredRaters.forEach((item, index) => {

                var onclickAction = "";
                if (index > 0) {
                    onclickAction = `onclick="$('.scrollTo').animate({ scrollTop: $('.scrollTo').scrollTop() + 65 } , 1000);"`;
                }

                let raterId = item.RaterId;
                if (item.tempIdCounter) {
                    disabled = ''
                    raterId = item.tempIdCounter
                }
                $('.removeCategory').show();
                let sendClasses = 'sendEntry';
                let copyClasses = 'copyLink';
                let deleteClasses = 'd-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry';
                let moveClasses = 'd-none d-sm-inline-block btn btn-sm btn-primary moveEntry';
                let moreButtonClasses = 'd-none d-sm-inline-block btn btn-sm btn-primary moreButton';

                if (item.tempIdCounter) {
                    sendClasses = '';
                    copyClasses = '';
                    moveClasses = 'd-none d-sm-inline-block btn btn-sm btn-gray';
                    moreButtonClasses = 'd-sm-inline-block btn btn-sm btn-primary disabled';
                }
                if (item.Status == 3) {
                    deleteClasses = 'd-none d-sm-inline-block btn btn-sm btn-gray';
                    //e.target.parentNode.parentNode.parentNode.parentNode.children[1].children[0].children[2].children[1].style.display = 'none';
                    setTimeout(() => {
                        $('.removeCategory').hide();
                    }, 100);
                }
                $('.ratersModalCategoryEntries').append(`
                    <div class="row" data-raterId="${raterId}" data-relationshipId="${relationshipId}" style="padding: 0px 2px;display: inline-flex;width: 100%;margin: 0px;position: relative;top: -13px;">
                        <div class="" style="padding: 0px;min-width:190px;"><input style="width:100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="First Name" name=FirstName type="text" value="${item.FirstName}" /></div>
                        <div class="" style="padding: 0 0 0 10px;min-width:190px;"><input style="width: 100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="Last Name" name="LastName" type="text" value="${item.LastName}" /></div>
                        <div class="" style="padding: 0 10px 0 10px;min-width:190px;width: 35%;"><input style="width: 100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="Email" name="Email" ${disabled} type="text" value="${item.Email}" /></div>
                        <div class="dinamicResponsive" style="width:25%;">
                            <!--<a class="${sendClasses}">
                                <span>Resend Invitation</span>
                                <i class="fas fa-paper-plane text-white-50"><span class="button-text"> Resend Invitation</span></i>
                            </a>-->
                            <a class="${moveClasses}">
                                <span class="button-text">Move</span>
                                <i class="fas fa-arrows-alt text-white-50"><span class="button-text"> Move</span></i>
                            </a>
                            <a class="${deleteClasses}">
                                <span class="button-text">Delete</span>
                                <i class="fas fa-trash text-white-50"><span class="button-text"> Delete</span></i>
                            </a>
                            <div style="display:inline-block; position:relative;">
                                <a ${onclickAction} data-toggle="dropdown" class="${moreButtonClasses}">
                                    <i style="display: inline-flex;margin-top: 0px;" class="fas fa-sort-down text-white-50">
                                        <span class="button-text" style="padding-left: 4px;"> Invitation</span>
                                    </i>
                                </a>
                                <ul class="dropdown-menu raters-dropdown-menu">
                                    <li data-raterId="${raterId}" class="${sendClasses}">
                                        <a class="${sendClasses}">Resend Invitation
                                        </a>
                                    </li>
                                    <li data-raterId="${raterId}" class="${copyClasses}">
                                        <a class="${copyClasses}">
                                            Copy link and code
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>    
                    </div>
                `);
            });

            //adding the minimun rater entries
            for (var i = 0; i < relationshipMin - filteredRaters.length; i++) {
                this.addNewRaterEntry(relationshipId);
            }
        } else {
            for (var i = 0; i < relationshipMin; i++) {
                this.addNewRaterEntry(relationshipId);
            }
        }
    }

    displayMinMessage(relationshipId: number) {
        //display min message if category doesnt have enought raters
        let categoryRaters = this.raters.filter((r) => {
            if (relationshipId == r.RelationshipId) return r;
        });

        let rt = this.raterTypes.findIndex(x => x.Id === relationshipId);
        let min;
        if (rt != -1) {
            min = this.raterTypes[rt].Min;
        }

        if (categoryRaters.length < min) {
            $('.categoryMinMessage span').text('You need a minimum of ' + min + ' raters for this category.');
        } else {
            $('.categoryMinMessage span').text('');
        }

        if (categoryRaters.length > 0) {
            $('.removeButtonText').text('Remove All');
        } else {
            $('.removeButtonText').text('Remove Category');
        }
    }

    addNewRaterEntry(relationshipId: number) {
        //get the relationship min
        let relationship = this.raterTypes.filter((rt) => {
            if (relationshipId == rt.Id) return rt;
        });

        let classes = "";
        if (relationship.length != 0) {
            classes = 'd-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry';
            let moreButtonClasses = 'd-none d-sm-inline-block btn btn-sm btn-primary moreButton';

            $('.ratersModalCategoryEntries').append(`
                    <div class="row" data-raterId="${this.tempId}${this.counter}" data-relationshipId="${relationshipId}" style="padding: 0px 2px;display: inline-flex;width: 100%;margin: 0px;position: relative;top: -13px;">
                        <div class="" style="padding: 0px;min-width:190px;"><input style="width:100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="First Name" name=FirstName type="text" value="" /></div>
                        <div class="" style="padding: 0 0 0 10px;min-width:190px;"><input style="width: 100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="Last Name" name="LastName" type="text" value="" /></div>
                        <div class="" style="padding: 0 10px 0 10px;min-width:190px;width: 35%;"><input style="width: 100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="Email" name="Email" type="text" value="" /></div>
                        <div class="dinamicResponsive" style="width:25%;">
                            <!--<a class="d-none d-sm-inline-block btn btn-sm btn-gray">
                                <span>Resend Invitation</span>
                                <i class="fas fa-paper-plane text-white-50"><span class="button-text"> Resend Invitation</span></i>
                            </a>-->
                            <a class="d-none d-sm-inline-block btn btn-sm btn-gray">
                                <span class="button-text">Move</span>
                                <i class="fas fa-arrows-alt text-white-50"><span class="button-text"> Move</span></i>
                            </a>
                            <a class="${classes}">
                                <span class="button-text">Delete</span>
                                <i class="fas fa-trash text-white-50"><span class="button-text"> Delete</span></i>
                            </a>
                            <div style="display:inline-block; position:relative">
                                <a class="${moreButtonClasses} disabled">
                                    <i style="display: inline-flex;margin-top: 0px;" class="fas fa-sort-down text-white-50">
                                        <span class="button-text" style="padding-left: 4px;"> Invitation</span>
                                    </i>
                                </a>
                            </div>
                        </div>                        
                    </div>
                `);
            this.counter++;
        }
    }

    openAddRelationshipsModal() {
        console.log('openAddRelationshipsModal');
        this.currentSelectedRelationshipsTab = 2;
        this.isStandard = true;

        this.raterTypesStandartDataHeaders = this.createRaterTypesHeaders();
        this.raterTypesCustomDataHeaders = this.createRaterTypesHeaders();
        this.getGlobalRaterTypes();//standart relationships
        this.getRaterTypesByCoach();//custom relationships
        this.showRelationshipsModal();

        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 500);
    }

    createRaterTypesHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 200,
            width: 200,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        return columnDefs;
    }

    getGlobalRaterTypes() {
        this._AdminService.getGlobalRaterTypes().subscribe((data: any) => {
            console.log('response_GetGlobalRaterTypes', data);
            this.loading = false;

            if (this._Globals.validationToken(data.result.Result)) {
                this.raterTypesStandartData = JSON.parse(data.result.Data);
                console.log('data', this.raterTypesStandartData);

                setTimeout(() => {
                    this.sizeToFit(this.raterTypesStandartGridApi);
                }, 100);
            }
        });
    }

    getRaterTypesByCoach() {
        this._CoachService.getRaterTypesByCoach().subscribe((data: any) => {
            console.log('response_GetRaterTypesByCoach', data);

            this.loading = false;
            if (this._Globals.validationToken(data.result.Result)) {
                this.raterTypesCustomData = JSON.parse(data.result.Data);
                console.log('data', this.raterTypesCustomData);

                if (this.addNewRelationship) {
                    this.getRaterTypesForCoach(true);
                }

            }
        });
    }

    showRelationshipsModal() {
        $('#ratersModalAddRelationshipsModal').modal('show');
        $('.rt-add-rater-types-modal li').removeClass('active').eq(0).addClass('active');
    }

    hideRelationshipsModal() {
        $('.rt-add-rater-types-modal li:first-child a').trigger('click');
        $('#ratersModalAddRelationshipsModal').modal('hide');
    }

    onRaterTypesStandartGridReady(params) {
        this.raterTypesStandartGridApi = params.api;
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    onRaterTypesCustomGridReady(params) {
        this.raterTypesCustomGridApi = params.api;
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    onRaterSelectionChanged(event) {
        console.log("onRaterSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");
    }

    loadData(type: number) {
        this.currentSelectedRelationshipsTab = type;

        switch (type) {
            case 1:
                console.log('1');
                this.isStandard = false;
                //this.getRaterTypesByCoach();
                setTimeout(() => {
                    this.sizeToFit(this.raterTypesCustomGridApi);
                }, 100);
                break;

            case 2:
                console.log('2');
                this.isStandard = true;
                //this.getGlobalRaterTypes();
                setTimeout(() => {
                    this.sizeToFit(this.raterTypesStandartGridApi);
                }, 100);
                break;
        }
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    addRelationships() {
        console.log('addRelationships');
        let standartRows = this.getSelectedRows(this.raterTypesStandartGridApi);
        let globalRows = this.getSelectedRows(this.raterTypesCustomGridApi);
        console.log('rows', standartRows);
        console.log('rows', globalRows);

        let rows = standartRows.concat(globalRows);

        let arrActiveCategories = [];
        let activeCategories = $('.ratersModalAcc .accOpen');
        console.log(activeCategories);
        for (var i = 0; i < activeCategories.length; i++) {
            let r = activeCategories[i].id.match(/\d/g).join(',');
            r = r.replace(/,/g, '');
            arrActiveCategories.push(parseInt(r));
        }

        rows.forEach((r) => {
            let categoryIndex = arrActiveCategories.findIndex(x => x === r.Id);
            if (categoryIndex == -1) {
                this.createCategoryContent(r.Id, r.Min, rows[rows.length - 1].Id);
            }
        });
        this.hideRelationshipsModal();
    }

    createCategoryContent(id, min, lastId?: number) {
        let accOpen = $('.ratersModalAcc .accOpen');
        let lastAcc;
        if (accOpen.length > 0) {
            lastAcc = accOpen[0].id;
            $(".ratersModalAcc #acc" + id).insertBefore('.ratersModalAcc #' + lastAcc);
        } else {
            $(".ratersModalAcc #acc" + id).insertAfter('.ratersModalAcc #forFirstelement');
        }
        $('.ratersModalAcc #acc' + id).css('display', 'block');
        $('.ratersModalAcc #acc' + id).removeClass('accHide');
        $('.ratersModalAcc #acc' + id).addClass('accOpen');
        this.lastCategory = id;

        this.checkRatersAmount();
        if (id == lastId) {
            $('.ratersModalAcc #acc' + id + ' .accDiv a').trigger('click');
            this.drawData(id, min);


            setTimeout(() => {
                let accOpen = $('.ratersModalAcc .accOpen');
                console.log(accOpen);
                $('.ratersModalAcc .accOpen')[0].children[0].children[0].children[0].children[1].classList.value = "fas fa-angle-up";
            }, 200);
        }
    }

    ngOnDestroy() {
        this.close();
        console.log("----------------NG-ON-DESTROY----------------------");
        // The selectors must match the ones used in ngAfterContentInit, otherwise jQuery doesn't remove the handlers
        // and they keep firing (with the destroyed component) on every click
        $(document).off('click', '#ratersModal .deleteRaterEntry');
        $(document).off('focusout', '.ratersModal .raterEntry');
        $(document).off('click', '#ratersModal .sendEntry');
        $(document).off('click', '#ratersModal .moveEntry');
        $(document).off('click', '#ratersModal .copyLink');
    }

    ngAfterContentInit() {
        $(document).on('click', '#ratersModal .deleteRaterEntry', (e) => {
            this.showDeleteRatersConfirmationModal(e);
            this.ratertoDelete = e;
        });

        $(document).on('focusout', '.ratersModal .raterEntry', (e) => {
            $(".raterEntry").off("focusout");
            this.editRaterEntry(e);
        });

        $(document).on('click', '#ratersModal .sendEntry', (e) => {
            $('body').css('cursor', 'wait');
            this.sendEmail(e);
        });

        $(document).on('click', '#ratersModal .moveEntry', (e) => {
            this.moveEntry(e);
        });

        $(document).on('click', '#ratersModal .copyLink', (e) => {
            $('body').css('cursor', 'wait');
            this.copyLink(e);
        });
        this.checkRatersAmount();
    }

    editRaterEntry(e: any) {
        if (!this.onlyOneceEdit) {
            this.onlyOneceEdit = true;
            console.log('focusout event', e);

            let raterId = e.target.parentElement.parentElement.dataset.raterid;
            console.log('raterId', raterId);

            let regex = /tempId/;
            let result = regex.test(raterId);
            let relationshipId = parseInt(e.target.parentElement.parentElement.dataset.relationshipid);

            if (!result) {
                let raterPosition = this.raters.findIndex(x => x.RaterId === parseInt(raterId));
                if (raterPosition != -1) {
                    if (e.target.name == 'Email') {
                        if (!this.validateEmail(e.target.value, raterPosition)) {
                            e.target.value = "";
                            //return;
                        }

                        if (this.sameClientEmail(e.target.value)) {
                            e.target.value = "";
                        }                        
                    }
                    if (this.raters[raterPosition][e.target.name] != e.target.value) this.raters[raterPosition].RecordStatus = 1;
                    this.raters[raterPosition][e.target.name] = e.target.value;
                    if (e.target.value != "") {
                        e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                    } else {
                        let canDisable = true;
                        for (var i = 0; i < 3; i++) {
                            if (e.target.parentNode.parentElement.children[i].children[0].value != "") {
                                canDisable = false;
                            }
                        }
                        if (canDisable) {
                            this.raters.splice(raterPosition, 1);
                            //e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                        }
                    }
                } else {
                    //let newRater = {
                    //    Email: "",
                    //    RaterId: 0,
                    //    FirstName: "",
                    //    LastName: "",
                    //    RelationshipId: relationshipId,
                    //    RecordStatus: 0,
                    //    tempIdCounter: 'tempId' + this.counter
                    //};
                    //this.raters.push(newRater);
                    //this.raters[this.raters.length - 1][e.target.name] = e.target.value;
                    //e.target.parentElement.parentElement.dataset.raterid = 'tempId' + this.counter;
                    //if (e.target.value != "") {
                    //    e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                    //} else {
                    //    let canDisable = true;
                    //    for (var i = 0; i < 3; i++) {
                    //        if (e.target.parentNode.parentElement.children[i].children[0].value != "") {
                    //            canDisable = false;
                    //        }
                    //    }
                    //    if (canDisable) {
                    //        this.raters.splice(this.raters.length, 1);
                    //        //e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                    //    }
                    //}
                    //this.counter++;
                }
            }
            else {
                //finding the position of the added memory entry tempIdCounter
                let raterPosition = this.raters.findIndex(
                    x => x.tempIdCounter == raterId
                );
                if (raterPosition != -1) {
                    if (e.target.name == 'Email') {
                        if (!this.validateEmail(e.target.value, raterPosition)) {
                            e.target.value = "";
                            //return;
                        }
                        if (this.sameClientEmail(e.target.value)) {
                            e.target.value = "";
                        }
                    }
                    this.raters[raterPosition][e.target.name] = e.target.value;
                    if (e.target.value != "") {
                        e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                    } else {
                        let canDisable = true;
                        for (var i = 0; i < 3; i++) {
                            if (e.target.parentNode.parentElement.children[i].children[0].value != "") {
                                canDisable = false;
                            }
                        }
                        if (canDisable) {
                            this.raters.splice(raterPosition, 1);
                            //e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                        }
                    }
                    //EDITING A MEMORY ENTRY
                } else {
                    //TOTALLY NEW ENTRY
                    console.log('relationshipId', relationshipId);

                    if (e.target.name == 'Email') {
                        if (!this.validateEmail(e.target.value, -1)) {
                            e.target.value = "";
                            //return;
                        }
                        if (this.sameClientEmail(e.target.value)) {
                            e.target.value = "";
                        }
                    }

                    let newRater = {
                        Email: "",
                        RaterId: 0,
                        FirstName: "",
                        LastName: "",
                        RelationshipId: relationshipId,
                        RecordStatus: 0,
                        tempIdCounter: raterId
                    };
                    this.raters.push(newRater);
                    this.raters[this.raters.length - 1][e.target.name] = e.target.value;
                    if (e.target.value != "") {
                        e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                    } else {
                        let canDisable = true;
                        for (var i = 0; i < 3; i++) {
                            if (e.target.parentNode.parentElement.children[i].children[0].value != "") {
                                canDisable = false;
                            }
                        }
                        if (canDisable) {
                            this.raters.splice(this.raters.length - 1, 1);
                            //e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                        }
                    }
                }
            }

            console.log('raters', this.raters);
            this.displayMinMessage(relationshipId);
            this.onlyOneceEdit = false;
        }

    }

    moveEntry(e) {
        console.log(e);

        let raterId, relationshipId;

        //button clicked
        if (e.target.nodeName == 'A') {
            relationshipId = parseInt(e.target.parentElement.parentElement.dataset.relationshipid);
            raterId = e.target.parentElement.parentElement.dataset.raterid;
        }
        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I') {
            relationshipId = parseInt(e.target.parentElement.parentElement.parentElement.dataset.relationshipid);
            raterId = e.target.parentElement.parentElement.parentElement.dataset.raterid
        }

        let regexM = /tempId/;
        let result = regexM.test(raterId);

        console.log('raterId', raterId);
        console.log('result', result);

        if (!result) {

            this.selectedRaterIdToMove = raterId;
            this.moveRowEntry = e;

            let activeCategories = $('.ratersModalAcc .accOpen');
            console.log(activeCategories);
            this.moveActiveCategories = [];
            for (var i = 0; i < activeCategories.length; i++) {
                let categoryId = activeCategories[i].id.match(/\d/g).join(','); 
                categoryId = categoryId.replace(/,/g, "");

                let categoryName = activeCategories[i].firstElementChild.innerText;

                if (categoryId != relationshipId ) {
                    this.moveActiveCategories.push({ "Id": categoryId, "Name": categoryName });
                }
            }
            console.log(this.moveActiveCategories);            

            this.showMoveEntryModal();

            console.log('this.raters', this.raters);

            //e.target
            //delete current element


        }        
    }

    showMoveEntryModal() {
        $('#moveEntryModal').modal('show');
        setTimeout(() => {
            $('#mCategories option').eq(0).prop('selected', true);
        }, 100);
    }

    hideMoveEntryModal() {
        $('#moveEntryModal').modal('hide');
        this.moveActiveCategories = [];
    }

    hideRemoveCategoryModel() {
        $('#removeCategoryModal').modal('hide');
    }

    confirmMoveEntry() {
        let selectedCategoryId = $('#mCategories').val();
        let selectedCategoryName = $("#mCategories option:selected").text();
        console.log('selectedCategoryId', selectedCategoryId);
        console.log('selectedCategoryName', selectedCategoryName);


        let rt = this.raters.findIndex(x => x.RaterId === parseInt(this.selectedRaterIdToMove));
        if (rt != -1) {
            this.raters[rt].RelationshipId = parseInt(selectedCategoryId);
            this.raters[rt].Relationship = selectedCategoryName;
            this.raters[rt].RecordStatus = 1;

            this.deleteRaterEntry(this.moveRowEntry, false);
        }

        console.log('this.raters', this.raters);
        this.hideMoveEntryModal();

    }

    sendEmail(e) {
        if (!this.onlyOneceSend) {
            this.onlyOneceSend = true;
            let raterId;
            //button clicked
            if (e.target.nodeName == 'A') {
                raterId = e.target.parentElement.dataset.raterid;
            }
            //child element clicked
            if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I') {
                raterId = e.target.parentElement.parentElement.dataset.raterid
            }

            let regex = /tempId/;
            let result = regex.test(raterId);

            if (!result) {

                this._RatersService.postSendEmail(this.assignmentId, [raterId]).subscribe((data: any) => {
                    console.log('response_sendEmail', data);
                    $('body').css('cursor', 'default');
                    if (this._Globals.validationToken(data.result.Result)) {
                        if (data.result.Result == 1) {
                            this._toastr.success("Email messages sent successfully", "ELI");
                        } else if (data.result.Result == 0) {
                            this._toastr.error("We are sorry. An error happened when trying to send the email messages.", "ELI");
                        }
                        setTimeout(() => {
                            $('#rtmainAccordion').trigger("click");
                        }, 100);
                    }
                    this.onlyOneceSend = false;
                });
            }
        }

    }

    copyLink(e) {
        if (!this.onlyOneceCopy) {
            this.onlyOneceCopy = true;
            console.log('copyLink');
            let raterId;
            //button clicked
            if (e.target.nodeName == 'A') {
                raterId = e.target.parentElement.dataset.raterid;
            }
            //child element clicked
            if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I') {
                raterId = e.target.parentElement.parentElement.dataset.raterid
            }

            let regex = /tempId/;
            let result = regex.test(raterId);

            if (!result) {
                this._RatersService.getCopyRaterLinkWithActivationCode(this.assignmentId, raterId).subscribe((data: any) => {
                    console.log('response_getCopyRaterLink', data);
                    $('body').css('cursor', 'default');
                    if (this._Globals.validationToken(data.result.Result)) {
                        if (data.result.Result == 1) {
                            console.log(data.result.Data);

                            let link = JSON.parse(data.result.Data);
                            $('#linkToCopy').text(link);

                            var $temp = $("<input>");
                            $("body").append($temp);
                            $temp.val($('#linkToCopy').text()).select();
                            document.execCommand("copy");
                            $temp.remove();

                            this._toastr.success('The assessment link has been copied to the clipboard', 'ELI');

                        } else if (data.result.Result == 0) {
                            this._toastr.error("We are sorry. An error happened when trying to get the assessment link", "ELI");
                        }
                        setTimeout(() => {
                            $('#rtmainAccordion').trigger("click");
                        }, 100);
                    }
                    this.onlyOneceCopy = false;
                });
            }
        }
    }

    showDeleteRatersConfirmationModal(e) {
        let showModal = false;
        let relationshipId;
        let raterId;

        //button clicked
        if (e.target.nodeName == 'A') {
            relationshipId = parseInt(e.target.parentElement.parentElement.dataset.relationshipid);
            raterId = e.target.parentElement.parentElement.dataset.raterid;
            for (var i = 0; i < 3; i++) {
                if (e.target.parentNode.parentNode.children[i].children[0].value != "") {
                    showModal = true;
                }
            }
        }

        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I') {
            relationshipId = parseInt(e.target.parentElement.parentElement.parentElement.dataset.relationshipid);
            raterId = e.target.parentElement.parentElement.parentElement.dataset.raterid;
            for (var i = 0; i < 3; i++) {
                if (e.target.parentNode.parentNode.parentNode.children[i].children[0].value != "") {
                    showModal = true;
                }
            }
        }

        //get the relationship min
        let relationship = this.raterTypes.filter((rt) => {
            if (relationshipId == rt.Id) return rt;
        });

        let inputEntries = $('.ratersModalAcc #acc' + relationshipId + ' .ratersModalCategoryEntries .row');
        if (showModal) {
            let raterPosition = this.raters.findIndex(x => x.RaterId === parseInt(raterId));
            if (raterPosition != -1) {
                if (this.raters[raterPosition].Status == 1) {
                    $("#ratersModalConfirmDeleteRatersModal").modal({ backdrop: "static" });
                    $('#ratersModalConfirmDeleteRatersModal').modal('show');
                } else {
                    this._toastr.warning('This rater cannot be deleted since she or he has already started or completed the assessment', 'ELI');
                    setTimeout(() => {
                        $('#rtmainAccordion').trigger("click");
                    }, 10);
                }
            }
            else {
                $("#ratersModalConfirmDeleteRatersModal").modal({ backdrop: "static" });
                $('#ratersModalConfirmDeleteRatersModal').modal('show');
            }

        } else {
            if (inputEntries.length > relationship[0].Min) {
                this.deleteRaterEntry(e, true); 
            } else {
                this._toastr.warning('You need a minimum of ' + relationship[0].Min + ' raters for this category', 'ELI');
                setTimeout(() => {
                    $('#rtmainAccordion').trigger("click");
                }, 10);
            }
        }
    }

    hideDeleteRatersConfirmationModal() {
        $('#ratersModalConfirmDeleteRatersModal').modal('hide');
    }

    confirmDeleteRaters() {
        this.inProgress = true;
        this.deleteRaterEntry(this.ratertoDelete, true);
    }

    deleteRaterEntry(e: any, addToDeleted: boolean) {
        console.log('click event', e);

        let raterId;

        //button clicked
        if (e.target.nodeName == 'A') {
            raterId = e.target.parentElement.parentElement.dataset.raterid;
        }

        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I') {
            raterId = e.target.parentElement.parentElement.parentElement.dataset.raterid
        }

        console.log('raterId', raterId);

        let regex = /tempId/;
        let result = regex.test(raterId);
        let relationshipId;

        //button clicked
        if (e.target.nodeName == 'A') {
            relationshipId = parseInt(e.target.parentElement.parentElement.dataset.relationshipid);
        }

        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I') {
            relationshipId = parseInt(e.target.parentElement.parentElement.parentElement.dataset.relationshipid);
        }
        console.log('relationshipId', relationshipId);

        if (!result) {
            //in database
            let raterPosition = this.raters.findIndex(x => x.RaterId === parseInt(raterId));
            if (raterPosition != -1) {
                if (addToDeleted) {
                    this.raters[raterPosition].RecordStatus = 2;
                    //relationshipId = this.raters[raterPosition].RelationshipId;
                    this.deletedRaters.push(this.raters[raterPosition]);
                    this.raters.splice(raterPosition, 1);
                }                
            }
        } else {
            //in memory
            let raterPosition = this.raters.findIndex(x => x.tempIdCounter === raterId);
            if (raterPosition != -1) {
                //relationshipId = this.raters[raterPosition].RelationshipId;
                this.raters.splice(raterPosition, 1);
            }
        }
        console.log('deleted', this.deletedRaters);
        //button clicked
        if (e.target.nodeName == 'A') {
            e.target.parentElement.parentElement.remove();
        }

        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I') {
            e.target.parentElement.parentElement.parentElement.remove();
        }

        //get the entries amount
        let entriesAmount = this.raters.filter((r) => {
            if (r.RelationshipId == relationshipId) return r;
        });
        //get the relationship min
        let relationship = this.raterTypes.filter((rt) => {
            if (relationshipId == rt.Id) return rt;
        });

        let inputEntries = $('.ratersModalAcc #acc' + relationshipId + ' .ratersModalCategoryEntries .row');
        if (entriesAmount.length < relationship[0].Min && inputEntries.length < relationship[0].Min) {
            this.addNewRaterEntry(relationshipId);
        }

        //display min message if category doesnt have enought raters
        this.displayMinMessage(relationshipId);

        this.hideDeleteRatersConfirmationModal();
        this.inProgress = false;
    }

    showBulkDeleteRatersConfirmationModal(rtId) {
        this.bulkDeleteCategoryId = rtId;

        let categoryRaters = this.raters.filter((r) => {
            if (rtId == r.RelationshipId) return r;
        });

        if (categoryRaters.length > 0) {
            $('.BDMessage').text('Are you sure to want to remove all the raters for this category (the category will be removed as well)?');
        } else {
            $('.BDMessage').text('Are you sure you want to remove this category from this assessment?');
        }

        $("#ratersModalBulkConfirmDeleteRatersModal").modal({ backdrop: "static" });
        $('#ratersModalBulkConfirmDeleteRatersModal').modal('show');
    }

    hideBulkDeleteRatersConfirmationModal() {
        $('#ratersModalBulkConfirmDeleteRatersModal').modal('hide');
    }

    confirmBulkDeleteRaters() {
        this.inProgress = true;
        this.removeCatergoryContent();
    }

    removeCatergoryContent() {
        console.log('removeCategoryContent');

        console.log('removeCategoryContent');

        this.raters.filter((r) => {
            if (this.bulkDeleteCategoryId === r.RelationshipId) {
                r.RecordStatus = 2;
                this.deletedRaters.push(r);
            };
        });

        console.log('deletedRaters', this.deletedRaters);

        this.raters = this.raters.filter((r) => {
            if (this.bulkDeleteCategoryId !== r.RelationshipId) return r;
        });
        console.log(this.raters);

        $('.ratersModalAcc #acc' + this.bulkDeleteCategoryId).css('display', 'None');
        $('.ratersModalAcc #acc' + this.bulkDeleteCategoryId).removeClass('accOpen');
        $('.ratersModalAcc #acc' + this.bulkDeleteCategoryId).addClass('accHide');
        $('.ratersModalAcc div').removeClass('in');
        this.checkRatersAmount();
        this.hideBulkDeleteRatersConfirmationModal();
        this.inProgress = false;
    }

    saveRaters() {
        setTimeout(() => {
            var time = new Date();
            let currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
            currentHour = currentHour.split(' ');
            this.addNewHour(parseInt(currentHour[0]) + 1, currentHour[1]);
        }, 100);

        //validation 
        let requirements = true;
        let missingRatersCategories = [];
        let missingRatersCategoriesIds = [];

        let activeCategories = $('.ratersModalAcc .accOpen');
        if (activeCategories.length == 0) {
            this._toastr.warning('You must enter raters for at least one category', 'ELI')
            return;
        }

        console.log(activeCategories);
        for (var i = 0; i < activeCategories.length; i++) {
            let r = activeCategories[i].id.match(/\d/g).join(',');
            //r = r.replace(",", "");
            r = r.replace(/,/g, '');
            missingRatersCategoriesIds.push(parseInt(r));
        }

        missingRatersCategoriesIds.forEach((item) => {
            let relationshipIndex = this.raterTypes.findIndex(x => x.Id === item);
            if (relationshipIndex != -1) {

                let relationshipsEntries = this.raters.filter((r) => { if (r.RelationshipId === item) return r });

                if (relationshipsEntries.length < this.raterTypes[relationshipIndex].Min) {
                    requirements = false;
                    $('a#' + this.raterTypes[relationshipIndex].Id + '.ng-tns-c2-0').css('color', 'red');
                    missingRatersCategories.push(' ' + this.raterTypes[relationshipIndex].Name);
                } else {
                    $('a#' + this.raterTypes[relationshipIndex].Id + '.ng-tns-c2-0').css('color', '#63ceeb');
                }
            }
        });
        let unic = this.removeDuplicates(missingRatersCategories);

        if (!requirements) {
            this._toastr.warning(`You have not entered the minimum raters required for the following categories: ${unic.join()}`, 'ELI');
            return;
        }

        let raters = this.raters.filter((r) => {
            if ('RecordStatus' in r) return r;
        });
        console.log("raters", raters);

        let missingData = false;
        raters.forEach((item) => {
            if (item.Email === "" || item.FirstName === "" || item.LastName === "") {
                missingData = true;
            }
        });

        if (missingData) {
            this._toastr.warning('Please complete all of the fields for the entered raters.', 'ELI');
            return;
        };

        //skeep the language and dates when there ir not new raters
        let newRaters = this.raters.filter((x) => {
            if (x.tempIdCounter) return x;
        });

        console.log('newRaters', newRaters);

        if (newRaters.length == 0) {
            console.log('skeep languages and dates');
            this.finishSaveRaters();
            return;
        }

        $("#ratersModalSaveRatersModal").modal({ backdrop: "static" });
        $('#ratersModalSaveRatersModal').modal('show');
        console.log('saveRaters');
        //this.addRaterNext();
        $("#ratersModalSaveRatersModal input[type=radio]").eq(0).prop("checked", true);
    }

    //addRaterNext() {
    //    this.addRaterPageIdx++;
    //    console.log(this.addRaterPageIdx);

    //    if (this.addRaterPageIdx == 1) {
    //        setTimeout(() => {
    //            var time = new Date();
    //            let currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
    //            currentHour = currentHour.split(' ');
    //            this.addNewHour(parseInt(currentHour[0]) + 1, currentHour[1]);
    //        }, 100);
    //    }
    //}

    removeDuplicates(arr) {
        let s = new Set(arr);
        let it = s.values();
        return Array.from(it);
    }

    getRaterTypesForCoach(refreshData: boolean) {
        this._CoachService.getRaterTypesForCoach().subscribe((data: any) => {
            console.log('response_GetRaterTypesForCoach', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let oneopen = $('.fa-angle-up').length;
                let _data = JSON.parse(data.result.Data);
                console.log('response_GetRaterTypesForCoach', _data);

                this.raterTypes = _data;
                this.rater.raterType = _data[0].Id;
                this.categoryMin = _data[0].Min;

                if (refreshData) {
                    let activeCategories = $('.ratersModalAcc .accOpen');
                    console.log(activeCategories);
                    this.arrActiveCategories = [];
                    for (var i = 0; i < activeCategories.length; i++) {
                        let r = activeCategories[i].id.match(/\d/g).join(',');
                        r = r.replace(/,/g, '');
                        this.arrActiveCategories.push(parseInt(r));
                    }

                    //let selected = this.parent.getSelectedRows(this.parent.gridApi360);
                    //this.clientId = selected[0].ClientId;
                    //this.getRaters(this.id, false, oneopen);

                    setTimeout(() => {
                        this.getRaters(this.id, false, oneopen);
                        if (this.addNewRelationship) {
                            $(`#ertcreateModal`).modal('hide'); 
                        }
                        $('body').css('cursor', 'default');
                    }, 1000);
                }
            }
        });
    }

    showConfirmCloseRatersModal() {
        let pristineCategories = [];
        let activeCategories = $('.ratersModalAcc .accOpen');
        console.log(activeCategories);

        for (var i = 0; i < $('.ratersModalAcc .accOpen').length; i++) {
            let r = activeCategories[i].id.match(/\d/g).join(',');
            r = r.replace(/,/g, '');
            pristineCategories.push(parseInt(r));
        }

        if (!this.arraysAreEqual(this.raters, this.pristineRaters) || !this.arraysAreEqual(this.pristineCategories, pristineCategories)) {
            $("#ratersModalConfirmCloseRatersModal").modal({ backdrop: "static" });
            $('#ratersModalConfirmCloseRatersModal').modal('show');
        } else {
            this.closeModal();
        }
    }

    closeModal() {
        this.close();
        this.addedRaters = [];
        this.editedRaters = [];
        this.deletedRaters = [];
        this.raters = [];
        this.arrActiveCategories = [];
        this.pristineCategories = [];
        this.executed = false;
        $('#rtmainAccordion .panel').css('display', 'none');
        //$('#relationships option')[0].selected = true;
        console.log('closeModal');
        $('.ratersModalAcc div').removeClass('in');
        $('#rtmainAccordion .panel').removeClass('accOpen');
        $('#rtmainAccordion .panel').addClass('accHide');
        $('.panel a').css('color', '#63ceeb');
        $('.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');

        //this.hideEcConfirmCloseRatersModal();
        //this.deselectAllCheckBox(this.gridApi);
    }

    arraysAreEqual(ary1, ary2) {
        console.log(JSON.stringify(ary1));
        console.log(JSON.stringify(ary2));
        return (JSON.stringify(ary1) == JSON.stringify(ary2));
    }

    hideConfirmCloseRatersModal() {
        $('#ratersModalConfirmCloseRatersModal').modal('hide');
    }

    isInArray(value, array) {
        return array.indexOf(value) > -1;
    }

    sameClientEmail(value) {
        if (value == this.clientEmail) {
            this._toastr.warning("A client cannot be assign her/himself as a rater", "ELI");
            setTimeout(() => {
                $('#rtmainAccordion').trigger("click");
            }, 100);

            return true;
        } else {
            return false;
        }
    }

    validateEmail(email: string, raterPosition: number): boolean {
        if (email !== "") {
            console.log("email", email);

            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            let validEmail = regex.test(email);
            console.log('Valid', validEmail)
            if (validEmail) {
                let exist = this.raters.findIndex(x => x.Email === email);
                if (exist != -1 && raterPosition != exist) {
                    this._toastr.warning('The specified Email address is already a rater for this assessment.', "ELI");
                    setTimeout(() => {
                        $('#rtmainAccordion').trigger("click");
                    }, 100);
                    return false;
                } else {
                    return true;
                }
            } else {
                this._toastr.warning('Please enter a valid email address', "ELI");
                setTimeout(() => {
                    $('#rtmainAccordion').trigger("click");
                }, 100);
                return false;
            }
        }
    }

    getCoachAssignedAssessmentsByType(assessmentType: number) {
        this._CoachService.getCoachAssignedAssessmentsByType(assessmentType).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('getCoachAssignedAssessmentsByType_response', _data);

                if (assessmentType === 1) {
                    this._Globals.assignedRegularData = _data;
                } else {
                    this._Globals.assigned360Data = _data;
                }

                this.loading = false;
            }
        });
    }

    getCoachAssignedAssessmentsByTypeByTag(assessmentType: number, tags: string[]) {
        this._CoachService.getCoachAssignedAssessmentsByTypeByTag(assessmentType, tags).subscribe((data: any) => {
            console.log('response_GetCoachAssignedAssessmentsByTypeByTag', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);
                if (_data.length > 0) {
                    if (assessmentType === 1) {
                        this._Globals.assignedRegularData = _data;
                    } else {
                        this._Globals.assigned360Data = _data;
                    }
                } else {
                    if (tags.length === 0) {
                        this.getCoachAssignedAssessmentsByType(assessmentType);
                    } else {
                        if (assessmentType === 1) {
                            this._Globals.assignedRegularData = [];
                        } else {
                            this._Globals.assigned360Data = [];
                        }
                    }
                }
            }

        });
    }

    /*raterTypesForModal*/
    openRaterTypesForModal() {
        this.raterTypesForModal.show(this, this.modalIndex);
    }

    showImportModal() {
        console.log('showImportModal');

        let pristineCategories = [];
        let activeCategories = $('.accOpen');
        console.log(activeCategories);

        for (var i = 0; i < $('.accOpen').length; i++) {
            let r = activeCategories[i].id.match(/\d/g).join(',');
            r = r.replace(/,/g, '');
            pristineCategories.push(parseInt(r));
        }

        if (!this.arraysAreEqual(this.raters, this.pristineRaters) || !this.arraysAreEqual(this.pristineCategories, pristineCategories)) {
            this._toastr.warning("Import raters is not allowed until you save your current changes", "ELI");
            return;
        }
        $("#ratersModalImportRaterModal").modal({ backdrop: "static" });
        $('#ratersModalImportRaterModal').modal('show');
    }

    closeImportModal() {
        $('#ratersModalImportRaterModal').modal('hide');
        $('#iFile').val('');
        this.fileName = "";
        this.blobFile = null;
        this.importRaterPageIdx = 0;
    }


    onDateSelect(date, divClass:string) {
        this.hourChanged(divClass);

        date.setHours(0, 0, 0, 0);
        console.log('onDateSelect', date);

        var today = new Date();
        today.setHours(0, 0, 0, 0);
        console.log("today", today);

        if (date < today) {
            this._toastr.warning("Please enter a date and time greater than the current date and time.", "ELI");
            this.date1 = new Date();
            this.setCurrentMinHour();
        }
    }

    setCurrentMinHour() {
        var time = new Date();
        var currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
        currentHour = currentHour.split(' ');
        currentHour[0] = parseInt(currentHour[0]);
        if (currentHour[0] == 12) {
            currentHour[0] = 0;
        }
        currentHour[0] = (currentHour[0] + 1) + "";

        if (currentHour[0].length == 1) {
            currentHour[0] = "0" + currentHour[0];
        }

        if (currentHour[0] == 12) {
            currentHour[1] = "PM";
        }
        currentHour = currentHour[0] + ":00 " + currentHour[1];
        console.log('current Hour', currentHour);
        $('#hour').val(currentHour);
        $('#importHour').val(currentHour);
    }

    addNewHour(minHour: number, type: string) {

        if (minHour == 13) {
            minHour = 1;
        }

        let amHours = [];
        let pmHours = [];

        if (type === "AM") {
            for (var i = minHour; i <= 11; i++) {
                if (i >= 10) {
                    amHours.push(i + ":00 AM");
                } else {
                    amHours.push("0" + i + ":00 AM");
                }
            }
            //adding the rest pm hours
            amHours.push("12:00 PM");
            minHour = 1;
            for (var j = minHour; j < 12; j++) {
                if (j >= 10) {
                    pmHours.push(j + ":00 PM");
                } else {
                    pmHours.push("0" + j + ":00 PM");
                }
            }
        } else {
            if (minHour == 12) {
                amHours.push("12:00 PM");
                minHour = 1;
            }
            for (var i = minHour; i < 12; i++) {
                if (i >= 10) {
                    pmHours.push(i + ":00 PM");
                } else {
                    pmHours.push("0" + i + ":00 PM");
                }
            }
        }
        console.log("this.hours", this.hours);
        this.hours = amHours.concat(pmHours);
        this.setCurrentMinHour();
    }

    closeNewRaterModal() {
        $('#ratersModalSaveRatersModal').modal('hide');
        $('#ratersModalSaveRatersModal').css('overflow', 'auto');
        console.log('hide');
        this.addRaterPageIdx = 0;
    }


    finishSaveRaters() {
        this.scheduledDate = $('.wc-date-container span').text();
        //this.scheduledDate = this.scheduledDate.slice(0, 10);
        let tempDate = this.scheduledDate.split(" ");
        this.scheduledDate = tempDate[0];
        this.scheduledDate = this.scheduledDate.replace(/-/g, "/");
        console.log('scheduledFor', this.scheduledDate);

        this.language = $('#languages').val();
        console.log('language', this.language);

        this.expiresIn = $('#expiresIn').val();
        console.log('expiresIn', this.expiresIn);

        this.selectedHour = $('#hour').val();
        //this.selectedGtmText = $("#gtm option:selected").text();
        //this.selectedGtmValue = $('#gtm').val();
        this.scheduleSelected = $("input[name='schedule']:checked").val();

        console.log(this.selectedHour);
        console.log(this.scheduleSelected);

        let rater = new RaterDto();
        rater.ClientId = this.clientId;
        rater.AsignmentId = this.assignmentId;
        rater.Language = this.language;

        if (this.scheduleSelected === "0") {
            var d = new Date();
            var n = d.getTimezoneOffset();
            this.selectedGtmValue = (n / 60);
        }

        rater.TimeOffSet = this.selectedGtmValue;
        if (this.expiresIn > 30) this.expiresIn = 30;
        rater.ExpiresIn = parseInt(this.expiresIn);

        if (this.scheduleSelected === "0") {
            rater.SendEmailInvitationNow = true;
            var today = new Date();
            var dd = today.getDate();
            var mm: any = today.getMonth() + 1;
            if (mm < 10) { mm = '0' + mm; }
            var yyyy = today.getFullYear();

            let date = `${mm}/${dd}/${yyyy}`;

            var time = new Date();
            var currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
            currentHour = currentHour.split(' ');
            rater.ScheduledFor = date + " " + currentHour[0] + ":00 " + currentHour[1];
        } else {
            rater.SendEmailInvitationNow = false;
            //var sDate = this.scheduledDate.split('/');
            //rater.ScheduledFor = sDate[1] + '/' + sDate[2] + '/' + sDate[0] + " " + this.selectedHour;
            ////rater.ScheduledTime = this.selectedHour;

            let scheduledFor = $('.assignedRadios .wc-date-container span').text();
            //let scheduledForArr = scheduledFor.split(' ');
            //scheduledFor = scheduledForArr[3];
            //scheduledFor = scheduledFor.substr(5);
            scheduledFor = scheduledFor.replace(/-/g, "/");
            console.log('scheduledFor', scheduledFor);

            rater.ScheduledFor = scheduledFor + " " + this.selectedHour;
        }

        let raters = this.raters.filter((r) => {
            if ('RecordStatus' in r) return r;
        });
        console.log("raters", raters);

        rater.Raters = raters.concat(this.deletedRaters);;
        console.log("save Rater", rater);

        $('body').css('cursor', 'wait');
        this.addingRater = true;

        this._ClientsService.postSaveRaters(rater).subscribe((data: any) => {
            console.log('response_PostSaveRater', data);
            $('body').css('cursor', 'default');
            if (this._Globals.validationToken(data.result.Result)) {

                switch (data.result.Result) {
                    case -1:
                        this._toastr.warning('The specified user is already a rater for this assessment.', 'ELI');
                        break;
                    case 0:
                        this._toastr.error('We are sorry. An error happend while trying to save the client.', 'ELI');
                        break;
                    case 1:
                        this.addedRaters = [];
                        this.editedRaters = [];
                        this.deletedRaters = [];
                        this.getRaters(this.assignmentId, true);
                        this._toastr.success('Raters updated successfully.', 'ELI');
                        this.closeNewRaterModal();
                        this.closeModal();
                        $('.ratersModalAcc div').removeClass('in'); 
                        $('#rtmainAccordion .panel').removeClass('accOpen');
                        $('#rtmainAccordion .panel').addClass('accHide');
                        $('.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');
                        //this.closeModal();
                        break;
                }
                this.addingRater = false;
            }
        });
    }

    hourChanged(divClass: string) {
        console.log('hourChanged');
        $(`.${divClass} input[type=radio]`).eq(0).prop("checked", false);
        $(`.${divClass} input[type=radio]`).eq(1).prop("checked", true);
    }

    getBlobFile(event: any) {
        console.log(event);
        let file = event.srcElement.value;
        console.log(file);
        let str = String.raw`\fakepath`;
        file = file.split(str);
        file = file[1].substring(1);
        this.fileName = file;

        this.blobFile = event.target.files[0];
    }

    importRaterNext() {
        if (this.blobFile == null) {
            this._toastr.warning("Please select an a .csv file.", "ELI");
            return;
        } else {
            // read as text
            const textReader = new FileReader();
            textReader.readAsText(this.blobFile);
            textReader.onload = () => {
                const csvContent = textReader.result as string;
                //const duplicates = this.findDuplicateEmails(csvContent);
                const duplicates = DuplicateEmailsManager.findDuplicateEmails(csvContent);

                if (duplicates.length > 0) {
                    console.warn('Emails duplicados encontrados:', duplicates);
                    this._toastr.warning(`We found duplicate emails: \n${duplicates.join(', ')}`, 'ELI');
                    $('body').css('cursor', 'default');
                    return; // stop the process
                }

                this.importRaterPageIdx++;
                console.log(this.importRaterPageIdx);

                if (this.importRaterPageIdx == 1) {
                    setTimeout(() => {
                        var time = new Date();
                        let currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
                        currentHour = currentHour.split(' ');
                        this.addNewHour(parseInt(currentHour[0]) + 1, currentHour[1]);
                    }, 100);
                }
            }
        }
    }

    importRaterPrev() {
        this.importRaterPageIdx--;
        console.log(this.importRaterPageIdx);
    }

    okImportRaters() {
        $('body').css('cursor', 'wait');
        this.blobToBase64(this.blobFile);
    }

    blobToBase64(blobFile) {
        var reader = new FileReader();
        reader.readAsDataURL(blobFile);
        reader.onload = () => {
            console.log("Base64 file", reader.result);
            let base64file: any = reader.result.toString();
            base64file = base64file.split(',');
            this.importClients(base64file[1].toString());
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
            $('body').css('cursor', 'default');
        };
    }

    importClients(base64file: string) {
        let importRatersDto = new ImportRatersDto();

        importRatersDto.clientId = this.clientId;
        importRatersDto.assignmentId = this.assignmentId;
        importRatersDto.data = base64file;

        let scheduledDate = $('.importRadios .wc-date-container span').text(); 
        //this.scheduledDate = this.scheduledDate.slice(0, 10);
        //let tempDate = scheduledDate.split(" ");
        //scheduledDate = tempDate[0];
        scheduledDate = scheduledDate.replace(/-/g, "/");
        console.log('scheduledFor', scheduledDate);

        let language = $('#importLanguages').val();
        console.log('language', language);
        importRatersDto.language = language;


        let expiresIn = $('#importExpiresIn').val();
        console.log('expiresIn', expiresIn);

        let selectedHour = $('#importHour').val();
        //this.selectedGtmText = $("#gtm option:selected").text();
        //this.selectedGtmValue = $('#gtm').val();
        let scheduleSelected = $("input[name='schedule']:checked").val();

        console.log(selectedHour);
        console.log(scheduleSelected);

        let selectedGtmValue;
        var d = new Date();
        var n = d.getTimezoneOffset();
        selectedGtmValue = (n / 60);
        importRatersDto.timeOffSet = selectedGtmValue;

        if (expiresIn > 30) expiresIn = 30;
        importRatersDto.expiresIn = parseInt(expiresIn);

        if (scheduleSelected === "0") {
            importRatersDto.sendEmailInvitationNow = true;
            var today = new Date();
            var dd = today.getDate();
            var mm: any = today.getMonth() + 1;
            if (mm < 10) { mm = '0' + mm; }
            var yyyy = today.getFullYear();

            let date = `${mm}/${dd}/${yyyy}`;

            var time = new Date();
            var currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
            currentHour = currentHour.split(' ');
            importRatersDto.scheduledFor = date + " " + currentHour[0] + ":00 " + currentHour[1];

        } else {
            importRatersDto.sendEmailInvitationNow = false;
            //var sDate = scheduledDate.split('/');
            //importRatersDto.scheduledFor = sDate[1] + '/' + sDate[2] + '/' + sDate[0] + " " + selectedHour;

            let scheduledFor = $('.importRadios .wc-date-container span').text();
            //let scheduledForArr = scheduledFor.split(' ');
            //scheduledFor = scheduledForArr[3];
            //scheduledFor = scheduledFor.substr(5);
            scheduledFor = scheduledFor.replace(/-/g, "/");
            console.log('scheduledFor', scheduledFor);

            importRatersDto.scheduledFor = scheduledFor + " " + selectedHour;
        }

        console.log('importRatersDto', importRatersDto);

        this._CoachService.postImportRaters(importRatersDto).subscribe((data: any) => {
            console.log('response_PostImportRaters', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_PostImportRaters data', _data);

                if (data.result.Result == 0) {
                    this._toastr.error("An error happened while trying to process the csv file.  Please verify that it is a valid file", "ELI");
                    $('body').css('cursor', 'default');
                } else if (data.result.Result == 1) {
                    this._toastr.success(`Total entries found: ${_data.TotalEntries} Imported: ${_data.SuccessEntries} Failed: ${_data.FailedEntries}`, "ELI");
                    this.getRaters(this.assignmentId, true);
                    this.closeImportModal();
                    $('body').css('cursor', 'default');
                    
                    this.executed = false;
                }
            }
        });
    }

    onRaterTypesRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            console.log(data);
            if (!this.isStandard) {
                this.openModal('Edit', data['Id'], data['Name']); //, data['Min']);
            }
        }
    }

    openModal(action: string, raterId: number, raterName: string) { //, raterMin: number) {
        if (!this.isStandard) {
            this.action = action;
            this.currentRaterId = raterId;
            this.rname = raterName;
            console.log($(`#ertcreateModal`));
            $(`#ertcreateModal`).modal({ backdrop: "static" });
            $(`#ertcreateModal`).modal('show'); 
            //$(`.${this.modalPrefix} #rtcreateEditModal`).modal({ backdrop: "static" });
            //$(`.${this.modalPrefix} #rtcreateEditModal`).modal('show');
        }
    }

    deleteRaterType() {
        this._AdminService.postDeleteRaterType(this.currentRaterId).subscribe((data: any) => {
            console.log('response_DeleteRaterType', data.result.Result);
            if (this._Globals.validationToken(data.result.Result)) {
                switch (data.result.Result) {
                    case 1:
                        this.getRaterTypesByCoach();
                        $(`#ertcreateModal`).modal('hide');
                        $(`#ecDeleteModal`).modal('hide');
                        this._toastr.success("Relationship deleted successfully", "ELI");
                        break;
                    case 0:
                        this._toastr.error("We are sorry.  An error happened while trying to delete the relationship", "ELI");
                        break;
                    case -1:
                        this._toastr.warning("This relationship cannot be deleted since it is being used in assessment assignments", "ELI");
                        break;
                }
            }
        });
    }

    //save rater type
    saveRaterType() {
        let raterType = new RaterTypeDto;
        raterType.Id = this.currentRaterId;
        raterType.Name = this.rname;
        raterType.Min = 3;
        raterType.IsGlobal = false;
        if (raterType.Name === "") {
            this._toastr.warning("The field name can not be empty.", "ELI");
            return;
        }
        //if (raterType.Min === null || raterType.Min < 0) {
        //    this._toastr.warning("Invalid entry for Min field.", "ELI");
        //    return;
        //}
        this.postSaveRaterType(raterType);
    }
    postSaveRaterType(raterType: RaterTypeDto) {
        $('body').css('cursor', 'wait');
        this._AdminService.postSaveRaterType(raterType).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                console.log('data', data);
                //this.getGlobalRaterTypes();
                this.addNewRelationship = true;
                this.getRaterTypesByCoach();
            } else {
                $('body').css('cursor', 'default');
            }
        })
    }

    public showRemoveCategoryInitialModal(raterType: number): void {
        this._CoachService.getCategoriesByAssignment(this.assignmentId.toString()) 
            .subscribe((response: any) => {
                if (this._Globals.validationToken(response.result.Result)) {
                    const categories: Array<any> = JSON.parse(response.result.Data);
                    console.log('getCategoriesByAssignment', categories);
                    if(categories.length > 1){
                        this.categoryToRemove = raterType;
                        this.assignmentNewCategories = 
                            categories.filter((c) => {
                                if (c.Id !== this.categoryToRemove) {
                                    return c;
                                } 
                            });
                        $("#assessmentNewCategory select").val(this.assignmentNewCategories[0].Id);
                        this.showRemoveCategoryModal();
                    } else {
                        this.showCannotDeleteCategoryModal();
                    }
                }
            });
    }


    showRemoveCategoryModal(): void {
        $(`#removeCategoryModal`).modal({ backdrop: "static" });
        $(`#removeCategoryModal`).modal('show');
    }


    showCannotDeleteCategoryModal(): void {
        $(`#cannotDeleteCategoryModal`).modal({ backdrop: "static" });
        $(`#cannotDeleteCategoryModal`).modal('show');
    }

    /*Confirmation Delete*/
    openConfirmationModal() {
        $(`#ecDeleteModal`).modal({ backdrop: "static" });
        $(`#ecDeleteModal`).modal('show');
    }
    closeModalConfirmation() {
        $(`#ecDeleteModal`).modal('hide');
    }

    preventSpace(value: string, event: any, id: string) {
        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == " ") {
            $('#' + id + '').val('');
        }
    }

    public removeCategory(relationshipsId: number): void {

    }

    public showNextStepRemoveCategory(): void {
       this._CoachService.getRaterCompleteAssignmentByType(this.assignmentId.toString(),this.categoryToRemove)
       .subscribe((response: any) => {
            if (this._Globals.validationToken(response.result.Result)) {
                this.raterCompleteAsignments = JSON.parse(response.result.Data);

                if (this.raterCompleteAsignments.length > 0){
                    this.hideRemoveCategoryModel();
                    this.showSelectNewCategoryModal();
                } else {
                    this.removeCategoryMovingCompleteRaters();
                }
            }
        });
    }

    public showSelectNewCategoryModal(): void {
        $(`#selectNewCategoryModal`).modal({ backdrop: "static" });
        $(`#selectNewCategoryModal`).modal('show');
    }

    public setNewCategory(newCategory: number): void {
        this.newCategory = newCategory;
        this.removeCategoryMovingCompleteRaters(this.newCategory);

        $(`#selectNewCategoryModal`).modal('hide');
    }

    private removeCategoryMovingCompleteRaters(newCategory: number = null): void {
        this._CoachService.postRemoveCategory(newCategory, this.categoryToRemove, this.assignmentId.toString())
            .subscribe((response: any) => {
                if (this._Globals.validationToken(response.result.Result)) {
                    this._toastr.success('Category removed successfully');
                }
                this.raters = this.raters.filter((r) => {
                    if (r.RelationshipId !== this.categoryToRemove) {
                        return r;
                    }
                });

                $('.ratersModalAcc #acc' + this.categoryToRemove).css('display', 'None');
                $('.ratersModalAcc #acc' + this.categoryToRemove).removeClass('accOpen');
                $('.ratersModalAcc #acc' + this.categoryToRemove).addClass('accHide');
                $('.ratersModalAcc div').removeClass('in');
                this.checkRatersAmount();
                this.getRaters(this.assignmentId, true);

                this.hideRemoveCategoryModel();
            },
            (error) => {
                this._toastr.error('Unexpected error removing the category.');
                this.hideRemoveCategoryModel();
            });
    }
}
